"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Logging = exports.Instrument = void 0;
var _instrumentBase = require("../../utils/instrument-base");
var _constants = require("../constants");
var _utils = require("../shared/utils");
class Instrument extends _instrumentBase.InstrumentBase {
  static featureName = _constants.FEATURE_NAME;
  constructor(agentIdentifier, aggregator, auto = true) {
    super(agentIdentifier, aggregator, _constants.FEATURE_NAME, auto);
    const instanceEE = this.ee;
    /** emitted by wrap-logger function */
    this.ee.on('wrap-logger-end', function handleLog([message]) {
      const {
        level,
        customAttributes
      } = this;
      (0, _utils.bufferLog)(instanceEE, message, customAttributes, level);
    });
    this.importAggregator();
  }
}
exports.Instrument = Instrument;
const Logging = exports.Logging = Instrument;